<template lang='pug'>
  .landing-page
    component(:is='component')
</template>
<script>
import { mapState } from 'vuex'
import { layoutMapping } from '@/modules/config/campaign'
import { dynamicLoadStore } from '@/mixins/store-util'
import { dyUtil } from '@/mixins/dyUtil'
import landingPage from '@/store/modules/landingPage'
import beautyFeedShow from '@/store/modules/beauty-feed-show'

export default {
  mixins: [
    dynamicLoadStore({ landingPage, beautyFeedShow }),
    dyUtil
  ],
  data () {
    return {
      component: {}
    }
  },
  computed: {
    ...mapState({
      landingPage: state => state.landingPage.landingPage,
      layout: state => state.landingPage.layout
    })
  },

  created () {
    this.$store.dispatch('fetchLandingPageLayout', {
      id: this.$route.params.id
    }).then(() => {
      this.setComponent()
      this.$store.dispatch('fetchLandingPage', {
        id: this.$route.params.id
      }).then(() => {
        this.$store.commit('setSeoMetaTitle', this.landingPage.attributes.seo['page-title'])
        this.$store.commit('setSeoMetaDescription', this.landingPage.attributes.seo['meta-description'])
        this.$store.commit('setSeoUpdate', true)
        this.initDY('OTHER')
      })
    })
  },

  methods: {
    setComponent () {
      const layoutName = layoutMapping[this.layout]
      if (layoutName) {
        this.component = () => import(`./${layoutName}/main.vue`)
      } else {
        this.component = () => import('../products/index/main.vue')
      }
    }
  }
}
</script>
